import { DateTime } from "luxon";

const ANCHOR = DateTime.fromISO("2026-10-01",{zone:"UTC"});
export function payPeriodForStart(value) {
  const start=DateTime.fromISO(String(value || ""),{zone:"UTC"});
  if(!start.isValid || !/^\d{4}-\d{2}-\d{2}$/.test(String(value)) || start.diff(ANCHOR,"days").days % 14 !== 0) return null;
  const end=start.plus({days:13}),check=start.plus({days:15});
  return {start:start.toISODate(),end:end.toISODate(),checkDate:check.toISODate(),label:`${start.toFormat("MM/dd/yyyy")} through ${end.toFormat("MM/dd/yyyy")}`,checkLabel:check.toFormat("MM/dd/yyyy")};
}
export function parsePayPeriod(value) {
  const text=String(value || "").trim();
  const direct=payPeriodForStart(text);
  if(direct)return direct;
  const match=text.match(/^(\d{2}\/\d{2}\/\d{4})\s+through\s+(\d{2}\/\d{2}\/\d{4})$/i);
  if(!match)return null;
  const date=DateTime.fromFormat(match[1],"MM/dd/yyyy",{zone:"UTC"});
  const period=payPeriodForStart(date.toISODate());
  return period && period.label.toLowerCase()===text.toLowerCase() ? period : null;
}
export const payPeriodLabel=value=>parsePayPeriod(value)?.label || String(value || "");
export const checkDateLabel=value=>parsePayPeriod(value)?.checkLabel || "";
export function payPeriodOptions(currentValue="") {
  const now=DateTime.now().setZone("America/New_York");
  const through=DateTime.fromObject({year:Math.max(2028,now.year+2),month:12,day:31},{zone:"UTC"});
  const options=[];
  for(let start=ANCHOR.minus({days:14});start<=through;start=start.plus({days:14}))options.push(payPeriodForStart(start.toISODate()));
  const selected=parsePayPeriod(currentValue);
  if(selected && !options.some(option=>option.start===selected.start))options.push(selected);
  return options.sort((a,b)=>a.start.localeCompare(b.start));
}
